import Vue from 'vue'
import App from '@/App'
import store from '@/store'
import router from '@/router'
import axios from 'axios'
import Tabs from 'vue-tabs-component'
import CustomPlugins from './plugins/index'
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns'
import { GridPlugin, PagerPlugin } from '@syncfusion/ej2-vue-grids'
import { TooltipPlugin } from '@syncfusion/ej2-vue-popups'
import { ChipListPlugin, RadioButtonPlugin, CheckBoxPlugin, ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'
import { AccordionPlugin, TabPlugin, TabComponent } from '@syncfusion/ej2-vue-navigations'
import { ToastPlugin } from '@syncfusion/ej2-vue-notifications'
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faExternalLinkAlt, faServer, faSearch, faUsers, faCalendar, faCalendarAlt, faProjectDiagram, faBorderAll, faBullhorn, faClock, faChevronLeft, faHotel, faImage, faLink, faList, faListAlt, faBan, faCode, faFile, faBinoculars, faPlus, faPlusCircle, faChevronDown, faPen, faPaperPlane, faTimes, faCheck, faEdit, faQuestionCircle, faCalendarCheck, faCalendarTimes, faExclamationCircle, faCommentAltCheck, faObjectGroup, faTasks, faSitemap, faInfoCircle, faClone, faUndo, faHistory, faTrash as trash } from '@fortawesome/pro-regular-svg-icons'
import { faEye, faEnvelopeOpenText, faMousePointer, faSync, faMinusCircle, faUsers as faLightUsers, faEnvelope, faSave, faArrowFromBottom, faCopy, faCheckCircle, faWindow, faUserTimes, faRepeat, faBrowser, faExclamationCircle as faLightExclamationCircle, faGripHorizontal, faTasks as faLightTasks, faTag, faTrash } from '@fortawesome/pro-light-svg-icons'
import { faCircle, faEllipsisV, faQuestionCircle as faQuestionCircleSolid } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueMoment from 'vue-moment'
import '@/scripts/filters'
import '@/scripts/directive'

library.add(faServer, faSearch, faUsers, faExternalLinkAlt, faEye, faCalendar, faCalendarAlt, faProjectDiagram, faBorderAll, faBullhorn, faCircle, faEnvelopeOpenText, faMousePointer, faSync, faMinusCircle, faExclamationCircle, faClock, faCopy, faClone, faChevronLeft, faHotel, faLightUsers, faEnvelope, faSave, faArrowFromBottom, faCheckCircle, faImage, faLink, faList, faListAlt, faBan, faCode, faFile, faBinoculars, faWindow, faPlus, faPlusCircle, faChevronDown, faPen, faEllipsisV, faPaperPlane, faTimes, faCheck, faEdit, faQuestionCircle, faCalendarCheck, faCalendarTimes, faUserTimes, faRepeat, faBrowser, faLightExclamationCircle, faTasks, faTag, faTrash, faGripHorizontal, faCommentAltCheck, faObjectGroup, faLightTasks, faSitemap, faInfoCircle, faUndo, faHistory, trash, faQuestionCircleSolid)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
Vue.component(TabPlugin.name, TabComponent)

Vue.config.productionTip = false

CustomPlugins.forEach(plg => Vue.use(plg))

Vue.use(Tabs)
Vue.use(GridPlugin)
Vue.use(PagerPlugin)
Vue.use(TooltipPlugin)
Vue.use(ChipListPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(CheckBoxPlugin)
Vue.use(VueMoment)
Vue.use(AccordionPlugin)
Vue.use(TabPlugin)
Vue.use(ToastPlugin)
Vue.use(TextBoxPlugin)
Vue.use(RadioButtonPlugin)
Vue.use(ButtonPlugin)
Vue.use(MultiSelectPlugin)

window.InitializationWatcher = {
  configLoaded: false
}
window.App = new Vue({
  router,
  store,
  axios,
  render: h => h(App)
})
window.App.$mount('#app')
